import HowItWorksFeature from './HowItWorksFeature'

export default HowItWorksFeature
